import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { formatErr } from "../lib/api";
import { toast } from "sonner";

const PHONE_RE = /^[6-9]\d{9}$/;

export default function Register() {
  const { register } = useAuth();
  const nav = useNavigate();
  const [form, setForm] = useState({ name: "", email: "", password: "", phone: "" });
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!PHONE_RE.test(form.phone)) { toast.error("Enter a valid 10-digit mobile number"); return; }
    setBusy(true);
    try {
      await register(form.email, form.password, form.name, form.phone);
      toast.success("Welcome to GOSHI");
      nav("/account");
    } catch (err) { toast.error(formatErr(err)); } finally { setBusy(false); }
  };

  const googleAuth = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    sessionStorage.setItem("goshi_auth_next", "/account");
    const redirectUrl = window.location.origin + "/auth/callback";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="pt-32 pb-24 px-6 md:px-12 min-h-screen flex items-center justify-center">
      <div className="w-full max-w-md space-y-8">
        <div className="text-center space-y-3">
          <p className="text-xs uppercase tracking-[0.3em] text-gold">Become a member</p>
          <h1 className="font-serif text-5xl">Create Account</h1>
          <p className="text-xs text-muted">Track orders, save addresses, and shop faster.</p>
        </div>

        <form onSubmit={submit} className="space-y-6" data-testid="register-form">
          <input className="input-line" placeholder="Full Name" required value={form.name} onChange={e => setForm({ ...form, name: e.target.value })} data-testid="register-name" />
          <input className="input-line" type="email" placeholder="Email" required value={form.email} onChange={e => setForm({ ...form, email: e.target.value })} data-testid="register-email" />
          <input
            className="input-line" type="tel" placeholder="Mobile (10-digit)" required
            value={form.phone}
            onChange={e => setForm({ ...form, phone: e.target.value.replace(/\D/g, "").slice(0, 10) })}
            data-testid="register-phone"
          />
          <input className="input-line" type="password" placeholder="Password (min 6 chars)" required minLength={6} value={form.password} onChange={e => setForm({ ...form, password: e.target.value })} data-testid="register-password" />
          <button className="btn-gold w-full" disabled={busy} data-testid="register-submit">{busy ? "Creating…" : "Create Account"}</button>
        </form>

        <div className="flex items-center gap-4">
          <div className="flex-1 h-px bg-[rgba(244,244,240,0.06)]" />
          <span className="text-xs uppercase tracking-[0.2em] text-muted">Or</span>
          <div className="flex-1 h-px bg-[rgba(244,244,240,0.06)]" />
        </div>

        <button onClick={googleAuth} className="btn-outline w-full" data-testid="google-auth-btn">Continue with Google</button>

        <p className="text-center text-sm text-muted">
          Already a member? <Link to="/login" className="text-gold underline-offset-4 hover:underline">Sign in</Link>
        </p>
      </div>
    </div>
  );
}
